import { useNavigate } from "@tanstack/react-router";
import { useRef } from "react";
import { gsap } from "gsap";

interface FooterLinkProps {
  href: string;
  to: string;
  children: React.ReactNode;
}

function FooterLink({ href, to, children }: FooterLinkProps) {
  const navigate = useNavigate();
  const underlineRef = useRef<HTMLSpanElement>(null);

  const handleMouseEnter = () => {
    gsap.fromTo(
      underlineRef.current,
      { scaleX: 0, transformOrigin: "left center" },
      {
        scaleX: 1,
        transformOrigin: "left center",
        duration: 0.5,
        ease: "power2.out",
      },
    );
  };

  const handleMouseLeave = () => {
    gsap.to(underlineRef.current, {
      scaleX: 0,
      transformOrigin: "right center",
      duration: 0.25,
      ease: "power2.in",
    });
  };

  return (
    <a
      href={href}
      className="text-primary relative w-max font-semibold whitespace-nowrap"
      onClick={(e) => {
        e.preventDefault();
        navigate({ to });
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      <span
        ref={underlineRef}
        className="bg-primary absolute bottom-0 left-0 h-[1.5px] w-full scale-x-0"
        style={{ transformOrigin: "left center" }}
      />
    </a>
  );
}

export default function Footer() {
  return (
    <footer className="flex w-full flex-row items-center justify-center gap-4 px-[5vw] text-sm">
      <FooterLink href="/privacy-policy" to="/privacy-policy">
        Privacy Policy
      </FooterLink>
      <span className="text-neutral-200">|</span>
      <FooterLink href="/terms-conditions" to="/terms-conditions">
        Terms & Conditions
      </FooterLink>
    </footer>
  );
}
